<template lang="html">
  <v-layout align-center justify-center>
    <v-flex xs12 lg8>
      <div style="display: overlay; background-color: white; float: left">
        <label
          class="black--text"
          style="margin-top: 0px; margin-bottom: 5px;"
        >
          {{label}}
        </label>

        <v-radio-group
          v-model="nota"
          :disabled="disabled"
          :required="required"
          :rules="rules"
          @change="setData"
          row
          dense
          style="margin-top: 0px; margin-bottom: 0px;"
        >
          <v-radio label="0" :value="0" ></v-radio>
          <v-radio label="1" :value="1" ></v-radio>
          <v-radio label="2" :value="2" ></v-radio>
          <v-radio label="3" :value="3" ></v-radio>
          <v-radio label="4" :value="4" ></v-radio>
          <v-radio label="5" :value="5" ></v-radio>
          <v-radio label="6" :value="6" ></v-radio>
          <v-radio label="7" :value="7" ></v-radio>
          <v-radio label="8" :value="8" ></v-radio>
          <v-radio label="9" :value="9" ></v-radio>
          <v-radio label="10" :value="10" ></v-radio>
        </v-radio-group>

        <v-divider style="margin-top: -5px; margin-bottom: 0px;"></v-divider>
        <v-divider style="margin-top: 0px; margin-bottom: 50px;"></v-divider>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    props: ['label', 'value', 'rules', 'clearable', 'required', 'disabled'],
    data: () => ({
      nota: undefined
    }),
    watch: {
      value: function (val) {
        this.nota = val
      }
    },
    methods: {
      setData () {
        this.$emit('input', this.nota)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// c-selecionar-nota.vue?ec5cae2a